













import { Component, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { ReturnPatient } from "@/api/pdReferral";

/**
 * 患者退回
 */
@Component({})
export default class PdReturnPatient extends AbpBase {
  @Prop() data: any;
  model: any = {};
  rules = {
    referralReason: [
      { required: true, message: "退回原因不能为空！", trigger: "blur" }
    ]
  };

  @Watch("data", { immediate: true, deep: true })
  onDataChanged() {
    if (this.data) {
      this.model = Object.assign({}, this.data);
    }
  }

  //提交退回患者请求
  async submit() {
    if (!this.model.referralReason) {
      this.$Message.error("退回原因不能为空！");
      return false;
    }
    await ReturnPatient(this.model);
    return true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdReferral/pdReceive/return.vue